const clean = (value) => (value ?? '').toString().trim();

export const buildValeManualRow = (form, localidad, formatDate) => ({
  ASEGURADORA: clean(form.aseguradora),
  COTIZACION: clean(form.cotizacion),
  PEDIDO: clean(form.pedido),
  FECHA_PEDIDO: formatDate(form.fechaPedido),
  PROMESA_DE_ENTREGA: formatDate(form.promesaEntrega),
  SINIESTRO: clean(form.siniestro),
  NOMBRE_COMERCIAL_TALLER: localidad?.taller || '',
  CIUDAD_TALLER: clean(form.ciudadTaller),
  ESTADO_TALLER: clean(form.estadoTaller),
  NOMBRE_CONTACTO: clean(form.nombreContacto),
  TELEFONO: clean(form.telefono),
  EMAIL: clean(form.email),
  ARMADORA: clean(form.armadora),
  MODELO: clean(form.modelo),
  ANIO: clean(form.anio),
  ITEM: clean(form.item),
  ORIGEN: clean(form.origen),
  PRECIO: clean(form.precio),
  ESTATUS: 'VALE MANUAL',
  BACK_ORDER: '',
  CODIGO: '',
  COSTO: '',
  LOCALIDAD: localidad?.localidad || '',
  CHOFER: '',
  COMPAQ: '',
  OC: clean(form.oc),
  NUEVO_ESTATUS: '',
  ESTATUS_LOCAL: '',
  ESTATUS_FORANEO: '',
  ESTATUS2: ''
});

export const guardarValeManual = async ({ apiBaseUrl, renglon, setRowData }) => {
  const response = await fetch(`${apiBaseUrl}/api/excel/guardar-excel`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify([renglon])
  });

  if (!response.ok) {
    throw new Error('No se pudo guardar el vale manual');
  }

  const refreshed = await fetch(`${apiBaseUrl}/api/excel/obtener-excel`);
  const data = await refreshed.json();
  setRowData(Array.isArray(data) ? data : []);
};
